import { xSequentialFill } from 'ml-spectra-processing';
export function padDataToNextPowerOfTwo(datum1D, digitalFilterApplied) {
    const { x, re, im } = datum1D.data;
    const size = nextPowerOfTwo(x.length);
    const newRE = new Float64Array(size);
    const newIM = new Float64Array(size);
    const grpdly = datum1D.info?.digitalFilter || 0;
    const pointsToShift = grpdly > 0 ? Math.floor(grpdly) : 0;
    newRE.set(re.slice(0, size - pointsToShift));
    newIM.set(im.slice(0, size - pointsToShift));
    if (pointsToShift > 0 && digitalFilterApplied) {
        newRE.set(re.slice(re.length - pointsToShift), size - pointsToShift);
        newIM.set(im.slice(re.length - pointsToShift), size - pointsToShift);
    }
    const newX = xSequentialFill({
        from: x[0],
        size,
        step: x[1] - x[0],
    });
    datum1D.data = { ...datum1D.data, re: newRE, im: newIM, x: newX };
}
function nextPowerOfTwo(n) {
    if (n === 0)
        return 1;
    n--;
    n |= n >> 1;
    n |= n >> 2;
    n |= n >> 4;
    n |= n >> 8;
    n |= n >> 16;
    return n + 1;
}
//# sourceMappingURL=padDataToNextPowerOfTwo.js.map